export default "__VITE_ASSET___RWziZ_y__"